import { Component, OnInit, inject, Input } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from '../service/UserService';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { FormsModule } from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DataService } from '../service/data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Order } from '../shared/models/order';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.scss'
})
export class PaymentsComponent  implements OnInit  {

  selectedFile: File | null = null;
  imageUrl: string | null = null;
  origin: string  = 'ecommerce-camben-comprobate-pago';
  uploading: boolean = false;

  granTotal: number = 0;
  value: string = '014580606068618551';
  tooltipMessage: string = 'Copiar clave interbancaria';
  isClicked: boolean = false;
  isCopied: boolean = false;
  tooltipDisabled: boolean = false;

  private _snackBar = inject(MatSnackBar);

  randomNumber: any;

  whatsappUrl: string = 'https://api.whatsapp.com/send?phone=528110760979&text=&source=&data=';

  selectedPaymentMethod: string = '';

  selected = 'Transferencia';

  isProcessingOrder: boolean = false;
  orderConfirmed: boolean = false;

  constructor(private router: Router,
              private userService: UserService,
              private data: DataService) { } // Removed CheckoutService injection

  ngOnInit(): void {
    this.generateRandomNumber()
    
    // Obtenemos el total desde localStorage
    const stored = localStorage.getItem('granTotal');
    this.granTotal = stored ? Number(stored) : 0;
  }

    paymentForm = new FormGroup({
      paymentMethod: new FormControl('', Validators.required)
    });

  generateRandomNumber(): number {
    const randomNumberA = Math.floor(100000 + Math.random() * 900000);
    this.randomNumber = randomNumberA;
    return randomNumberA;
  }

 onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    if (this.selectedFile) {
      this.uploadImage();
    }
  }

  uploadImage(): void {
    if (this.selectedFile) {
      this.uploading = true;
      this.data.uploadImage(this.selectedFile, this.origin).subscribe(
        (response) => {
          this.uploading = false;
          this.imageUrl = response.data.url;
          // Guardamos el total en localStorage antes de navegar
          localStorage.setItem('granTotal', String(this.granTotal));
          // Agrega esta línea para guardar la URL en sessionStorage
          localStorage.setItem('urlImagenComprobante', this.imageUrl!);
          this.openSnackBar("Imagen cargada con exito", "¡Confirmar pedido!");
        },
        (error) => {
           this.uploading = false;
            this.openSnackBar("falla en la carga de imagen", "¡Inténtalo nuevamente!");
        }
      );
    }
  }

  onPaymentMethodChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedPaymentMethod = selectElement.value;
  }

  confirmPedido(): void {
    localStorage.setItem('randomNumber', this.randomNumber!);
    this.router.navigate(['/secure-checkout']);
  }
   

 onCopy() {
     this.isClicked = true;
     this.isCopied = true;
     this.tooltipMessage = '¡Copiado!';
     this.tooltipDisabled = false;

     setTimeout(() => {
       this.isClicked = false;
     }, 200);
   }

   onHover() {
     if (!this.isCopied) {
       this.tooltipMessage = 'Copiar clave interbancaria';
       this.tooltipDisabled = false;
     }
   }

   resetIconColor() {
     if (!this.isClicked && !this.isCopied) {
       this.tooltipDisabled = true;
     }
   }

   resetTooltip() {
     this.tooltipMessage = 'Copiar clave interbancaria';
     this.tooltipDisabled = true;
   }

openSnackBar(message: string, action: string): void {
  const snackBarRef = this._snackBar.open(message, action, {
                                             duration: 1000,
                                           });
  snackBarRef.onAction().subscribe(() => {
    this.confirmPedido();
  });
}


  regresar(): void {
    this.router.navigate(['/cart']);
   }
}
